import { getGlobalEventsLogs, IEvent, createConsumer, createSubscriber } from '@cian/events-log';
import * as React from 'react';

type TUseAuthParameters = {
  onSuccess?(): void;
  onCloseNoAuth?(): void;
};

export const useAuth = ({ onSuccess, onCloseNoAuth }: TUseAuthParameters = {}) => {
  const requestAuthentication = () => {
    const globalLog = getGlobalEventsLogs();

    globalLog.produce('user', {
      type: 'authenticate',
      value: { autoRefresh: false },
    });
  };

  React.useEffect(() => {
    const consumer = createConsumer({ topic: 'user' });

    const userSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'authenticated') {
        consumer.unsubscribe(userSubscriber);

        if (onSuccess) {
          onSuccess();
        }

        window.location.reload();

        return;
      }

      if (event.type === 'authentication_modal_closed') {
        /* istanbul ignore else */
        if (onCloseNoAuth) {
          onCloseNoAuth();
        }

        consumer.unsubscribe(userSubscriber);
      }
    });

    consumer.subscribe(userSubscriber);

    return () => {
      consumer.unsubscribe(userSubscriber);
      consumer.destroy();
    };
  });

  return { requestAuthentication };
};
